
import Excel from 'exceljs'


export async function asExcel(rows: any, fields: any) {
  const workbook = new Excel.Workbook();
  const sheet = workbook.addWorksheet('MGSL Samples')
  const header = sheet.getRow(1)
  fields.forEach((key: string, i: number) => header.getCell(i + 1).value = key)
  let k = 2
  for (const row of rows) {
    const r = sheet.getRow(k)
    fields.forEach((key: string, i: number) => {
      r.getCell(i + 1).value = row[key]
    })
    k += 1
  }
  return workbook.xlsx.writeBuffer()
}
